export default class VerifyEmailRequestData {
  public email: string

  public constructor (email: string) {
    this.email = email
  }
}
